/**
 * Prompt rewrite API client
 */

import { apiClient } from './client';

export interface PromptRewriteRequest {
  selected_text: string;
  instruction: string;
  context?: string;
  model?: string;
}

export interface PromptRewriteResponse {
  rewritten_text: string;
}

export const promptRewriteApi = {
  rewrite: async (data: PromptRewriteRequest): Promise<PromptRewriteResponse> => {
    const response = await apiClient.post<PromptRewriteResponse>(
      '/prompt-rewrite/rewrite',
      data,
      { timeout: 120_000 },
    );
    return response.data;
  },
};
